import { apiClient } from "../../utils/apiClient";
import { Employee } from "../../types/employee";

export const fetchEmployeeAll = (): Promise<any> => {
    return apiClient.get(`/employee`).then((response) => response.data);
}

export const fetchEmployeeByCode = (no_emple: string): Promise<Employee[]> => {
    return apiClient.get(`/employee/code/${no_emple}`).then((response) => response.data);
}

export const upsertEmployee = (newEmployee: Employee): Promise<Employee> => {
    return apiClient.post("/employee", newEmployee).then((response => response.data));
}